import React, { Component } from "react";
import ReactDOM from "react-dom";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
// import { FlagsProvider } from "react-unleash-flags";
import { SendToast } from "@networkraildigitalfactory/components";
import { ConfigProvider } from "antd";
import cloudURL from "./services/cloud";
import AppContext from "./services/appContext";
import { checkAuthenticated, logout } from "./services/session";
import Routes from "./routes";
import { getBuild, getCurrentFinancialYear } from "./services/utils";

toast.configure();

// const flagConfig = {
//   appName: getBuild().env,
//   url: "https://gitlab.com/api/v4/feature_flags/unleash/18642810",
//   instanceId: "2UnCmUxZ7ty-qbTEf9Wy",
// };

class App extends Component {
  constructor(props) {
    super(props);

    const auth = checkAuthenticated();
    const user = JSON.parse(localStorage.getItem("user"));
    if (getBuild().env !== "PROD") {
      // eslint-disable-next-line global-require
      const axe = require("@axe-core/react");
      axe(React, ReactDOM, 1000, {});
    }
    this.state = {
      prevPath: "",
      authenticated: auth.authenticated,
      loading: false,
      loadingText: "Loading...",
      title: "iPerform",
      unsavedChanges: false,
      user,
      isDirtyForm: false,
      isUserProfileValid: false,
      isLineManager: false,
      isFirstLogin: false,
      isSecondScreen: false,
      isWhatsNewModalOpen: true,
      isOnboardingModalOpen: true,
      objectivesFilters: {
        status: "",
        dueDate: "",
        page: 1,
        pageSize: 5,
      },
      oneToOnesFilters: {
        year: getCurrentFinancialYear(),
      },
      performancesFilters: {
        financialYear: "",
        year: getCurrentFinancialYear(),
        page: 1,
        pageSize: 3,
      },
      isDraftPrep: false,
      navModalProps: { show: false, navPath: "/" },
      setIsOnboardingModalOpen: this.setIsOnboardingModalOpen,
      setIsWhatsNewModalOpen: this.setIsWhatsNewModalOpen,
      setNavModalProps: this.setNavModalProps,
      setIsDirtyForm: this.setIsDirtyForm,
      setIsDraftPrep: this.setIsDraftPrep,
      setObjectivesFilters: this.setObjectivesFilters,
      setOneToOnesFilters: this.setOneToOnesFilters,
      setPerformancesFilters: this.setPerformancesFilters,
      setIsSecondScreen: this.setIsSecondScreen,
      setFirstLogin: this.setFirstLogin,
      logout: this.onLogout,
      setAuthenticated: this.onAuthenticated,
      setLoading: this.onSetLoading,
      setUnsavedChanges: this.onSetUnsavedChanges,
      setIsLineManager: this.setIsLineManager,
      updateUser: this.updateUser,
      setEmployeeBeingViewed: this.setEmployeeBeingViewed,
    };

    document.body.addEventListener("mousedown", function () {
      document.body.classList.add("using-mouse");
    });

    document.body.addEventListener("keydown", function (event) {
      if (event.keyCode === 9) {
        document.body.classList.remove("using-mouse");
      }
    });
  }

  componentWillMount() {
    // always use 'withCredentials'
    axios.interceptors.request.use(
      (config) => {
        config.withCredentials = true;
        return config;
      },
      (error) => {
        if (error.response && error.response.status === 403) {
          this.onLogout();
          SendToast("Your session has expired. Please log in.", "error");
        }
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response && error.response.status === 403) {
          this.onLogout();
          SendToast("Your session has expired. Please log in.", "error");
        }
        return Promise.reject(error);
      }
    );

    if (window.location.pathname !== "/login") {
      this.setIsLineManager();
    }

    if (window.location.pathname === "/") {
      localStorage.setItem("employeeBeingViewed", JSON.stringify({ fullName: "", email: "" }));
    }

    // handle redirect for manager activity report
    if (window.location.pathname.includes("/my-team/")) {
      this.redirectFromEmail("lineManagerRedirect");
    } else if (
      window.location.pathname.includes("/view-1-2-1/") &&
      !window.location.pathname.includes("/my-team/")
    ) {
      this.redirectFromEmail("emp121Redirect");
    } else if (window.location.pathname.includes("/view-objective/")) {
      this.redirectFromEmail("empObjRedirect");
    } else if (window.location.pathname === "/my-notifications") {
      this.redirectFromEmail("notificationsRedirect");
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setState({ prevPath: this.props.location.pathname });
    }
  }

  redirectFromEmail = (type) => {
    const { pathname } = window.location;

    // eslint-disable-next-line default-case
    switch (type) {
      case "lineManagerRedirect":
        localStorage.setItem("lineManagerRedirect", pathname);
        break;
      case "emp121Redirect":
        localStorage.setItem("emp121Redirect", pathname);
        break;
      case "empObjRedirect":
        localStorage.setItem("empObjRedirect", pathname);
        break;
      case "notificationsRedirect":
        localStorage.setItem("notificationsRedirect", pathname);
        break;
    }
  };

  onSetLoading = (loading, loadingText = "Loading...") => {
    this.setState({
      loading,
      loadingText,
    });
  };

  onSetUnsavedChanges = (unsavedChanges) =>
    new Promise((resolve) => {
      this.setState({ unsavedChanges });
      resolve();
    });

  onAuthenticated = (authenticated) => {
    const user = JSON.parse(localStorage.getItem("user"));
    this.setState({
      authenticated,
      user,
    });
  };

  onLogout = async () => {
    this.onSetLoading(true, "Logging out...");
    this.onAuthenticated(false);
    this.onSetLoading(false);
    this.props.history.push("/login");
    await logout();
  };

  updateUser = (user) => {
    user.data = { ...this.state.user.data, ...user.data };
    localStorage.setItem("user", JSON.stringify(user));
    this.setState({
      user,
      isUserProfileValid: user.isValidProfile,
    });
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("isUserProfileValid", JSON.stringify(user.isValidProfile));
  };

  // eslint-disable-next-line consistent-return
  setIsLineManager = async () => {
    try {
      const response = await axios.post(`${cloudURL()}/users/managedBy`, {
        email: this.state.user && this.state.user.data.email,
      });
      if (response) {
        this.setState((prevState) => ({
          isLineManager: response.data.isLineManager,
          ...prevState.isLineManager,
        }));
        localStorage.setItem("isLineManager", JSON.stringify(response.data.isLineManager));
        return Promise.resolve(response.data.isLineManager);
      }
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  };

  setIsWhatsNewModalOpen = (state) => {
    this.setState({ isWhatsNewModalOpen: state });
  };

  setIsOnboardingModalOpen = (state) => {
    this.setState({ isOnboardingModalOpen: state });
  };

  setNavModalProps = (state) => {
    this.setState({ navModalProps: state });
  };

  setIsDirtyForm = (state) => {
    this.setState({ isDirtyForm: state });
  };

  setIsDraftPrep = (state) => {
    this.setState({ isDraftPrep: state });
  };

  setFirstLogin = (state) => {
    this.setState({ isFirstLogin: state });
  };

  setIsSecondScreen = (state) => {
    this.setState({ isSecondScreen: state });
  };

  setEmployeeBeingViewed = (employeeData) => {
    localStorage.setItem("employeeBeingViewed", JSON.stringify(employeeData));
  };

  setObjectivesFilters = (field, value) => {
    const currentItems = this.state.objectivesFilters;
    currentItems[field] = value;
    this.setState((prevState) => ({
      objectivesFilters: currentItems,
      ...prevState.objectivesFilters,
    }));
  };

  setOneToOnesFilters = (field, value) => {
    const currentItems = this.state.oneToOnesFilters;
    currentItems[field] = value;
    this.setState((prevState) => ({
      oneToOnesFilters: currentItems,
      ...prevState.oneToOnesFilters,
    }));
  };

  setPerformancesFilters = (field, value) => {
    const currentItems = this.state.performancesFilters;
    currentItems[field] = value;
    this.setState((prevState) => ({
      performancesFilters: currentItems,
      ...prevState.performancesFilters,
    }));
  };

  render() {
    return (
      <ConfigProvider theme={{ hashed: false }}>
        <AppContext.Provider value={this.state}>
          {/* <FlagsProvider config={flagConfig}> */}
          <Routes user={this.state.user} />
          {/* </FlagsProvider> */}
        </AppContext.Provider>
      </ConfigProvider>
    );
  }
}

export default withRouter(App);
